import React from 'react';

const channels = ['Instagram', 'WhatsApp', 'Messenger', 'LinkedIn', 'Gmail', 'Outlook', 'Webchat', 'Telegram', 'X', 'TikTok'];

function ChannelsMarquee() {
  const doubled = [...channels, ...channels];
  return (
    <div className="wrap">
      <div className="chanwrap">
        <div className="chantrack">
          {doubled.map((c, i) => (
            <span key={i} className="chan">{c}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ChannelsMarquee;
